// Stránka investičních bytů EFI Palace (includes/redesign/reality-palace.php):
//  - filtr ceníku etapa / dispozice ([data-palace-filter]) + přeskládání řádků FONDEFI po N bytech (návrh withAds()),
//  - kalkulačka nájmu a zhodnocení ([data-palace-calc], návrh renderVals() – calc*, grow*),
//  - předvyplnění formuláře „Nezávazný dotaz“ z odkazu detailu bytu (?byt=A-204&zajem=uz&poznamka=…#kontakt),
//  - detail bytu: volba délky nájmu u varianty A mění odkaz a popisek tlačítka ([data-palace-std]).

function numberFormat(value, decimals, lang) {
  const sep = { en: ['.', ','], de: [',', '.'] }[lang] || [',', ' '];
  const fixed = Math.abs(value).toFixed(decimals);
  const [int, dec] = fixed.split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, sep[1]);
  return (value < 0 ? '−' : '') + grouped + (dec ? sep[0] + dec : '');
}

function plural(n, words) {
  if (n === 1) {
    return words[0];
  }
  return n >= 2 && n <= 4 ? words[1] : words[2];
}

function initFilter() {
  const filter = document.querySelector('[data-palace-filter]');
  const table = document.querySelector('#nabidka [data-palace-table]');
  if (!filter || !table) {
    return;
  }

  const lang = filter.dataset.lang || 'cs';
  const czk = (n) => `${numberFormat(n, 0, lang)} ${filter.dataset.czk || 'Kč'}`;
  const tbody = table.tBodies[0];
  const rows = Array.from(tbody.querySelectorAll('[data-palace-unit]'));
  const adTemplate = tbody.querySelector('[data-palace-ad]');
  const every = Number(table.dataset.adEvery) || 0;
  const shown = filter.querySelector('[data-palace-shown]');

  function apply() {
    const bld = (filter.querySelector('input[name="palace-bld"]:checked') || {}).value || 'all';
    const disp = (filter.querySelector('input[name="palace-disp"]:checked') || {}).value || 'all';
    const visible = rows.filter((row) => (bld === 'all' || row.dataset.bld === bld) && (disp === 'all' || row.dataset.disp === disp));

    tbody.querySelectorAll('[data-palace-ad]').forEach((ad) => ad.remove());
    rows.forEach((row) => {
      row.hidden = !visible.includes(row);
    });
    // řádky ve stejném pořadí, za každý N-tý viditelný a na konec reklama FONDEFI
    rows.forEach((row) => tbody.appendChild(row));
    if (adTemplate && every > 0) {
      visible.forEach((row, i) => {
        if ((i + 1) % every === 0) {
          row.after(adTemplate.cloneNode(true));
        }
      });
      if (visible.length % every !== 0) {
        tbody.appendChild(adTemplate.cloneNode(true));
      }
    }

    if (shown) {
      const prices = visible.map((row) => Number(row.dataset.price));
      const words = [filter.dataset.wordOne, filter.dataset.wordFew, filter.dataset.wordMany];
      shown.textContent = `${visible.length} ${plural(visible.length, words)}${prices.length ? ` · ${filter.dataset.from} ${czk(Math.min(...prices))} ${filter.dataset.to} ${czk(Math.max(...prices))}` : ''}`;
    }
  }

  filter.addEventListener('change', apply);
}

function initCalc() {
  const root = document.querySelector('[data-palace-calc]');
  if (!root) {
    return;
  }

  let data;
  try {
    data = JSON.parse(root.dataset.palaceCalc);
  } catch (e) {
    return;
  }
  const t = data.t;
  const lang = data.lang || 'cs';
  const czk = (n) => `${numberFormat(Math.round(n), 0, lang)} ${t.czk}`;
  const pct1 = (v) => `${numberFormat(v, 1, lang)} %`;
  const yieldPct = (share) => {
    const v = Math.round(share * 1000) / 10;
    return `${numberFormat(v, Number.isInteger(v) ? 0 : 1, lang)} %`;
  };
  const yearsWord = (n) => `${n} ${n === 1 ? t.yr1 : n < 5 ? t.yr2 : t.yr5}`;
  const out = (name) => root.querySelector(`[data-out="${name}"]`);
  const set = (name, text) => {
    const el = out(name);
    if (el) {
      el.textContent = text;
    }
  };

  function render() {
    const key = root.querySelector('[data-calc="unit"]').value;
    const mode = (root.querySelector('[data-calc="mode"]:checked') || {}).value || 'std';
    const years = Number((root.querySelector('[data-calc="years"]:checked') || {}).value || 5);
    const growth = Number(root.querySelector('[data-calc="growth"]').value || 0);
    const u = data.units[key];
    if (!u) {
      return;
    }

    const isUz = mode === 'uz';
    const uzPrice = (u.uz && u.uz[years]) || u.price;
    const paid = isUz ? uzPrice : u.price;
    const discount = isUz ? u.price - uzPrice : 0;
    const year = isUz ? 0 : u.rentY;
    const month = isUz ? 0 : Math.round(u.rentY / 12);
    const yieldText = yieldPct(u.price ? u.rentY / u.price : 0);
    const pctOf = (v) => `+${pct1((v / paid) * 100)}`;
    const endPrice = u.price * (1 + growth / 100) ** years;
    const endGain = endPrice - u.price;
    const extra = isUz ? discount : year * years;

    set('modeHint', isUz ? t.modeUzHint : t.modeStdHint);
    set('yearsLabel', isUz ? t.calcYearsUz : t.calcYears);
    set('growLabel', `${numberFormat(growth, growth % 1 ? 1 : 0, lang)} %`);
    set('stdPrice', czk(u.price));
    set('payLabel', isUz ? t.calcPayUz.replace('{years}', yearsWord(years)) : t.calcPayStd);
    set('price', czk(paid));
    set('payNote', isUz ? t.calcPayUzNote.replace('{diff}', czk(discount)) : t.calcPayStdNote.replace('{yield}', yieldText));
    set('month', czk(month));
    set('rentNote', isUz ? t.calcRentNoneUz : t.calcYield.replace('{yield}', yieldText));
    set('rentSumLabel', `${t.calcRentSum} ${yearsWord(years)}`);
    set('rentSum', czk(year * years));
    set('rentSumPct', isUz ? t.calcRentNoneUz : pctOf(year * years));
    set('discount', isUz ? `+${czk(discount)}` : czk(0));
    set('discountPct', isUz ? `−${pct1((discount / u.price) * 100)} ${t.ofStdPrice}` : t.calcDiscountNone);
    set('endLabel', `${t.growEndLabel} ${t.growAfter[years - 1]}`);
    set('endPrice', czk(endPrice));
    set('endGain', `+${czk(endGain)}`);
    set('totalLabel', t.growTotalLabel.replace('{years}', yearsWord(years)));
    set('total', `+${czk(endGain + extra)}`);
    set('totalPct', pctOf(endGain + extra));
    set('colRent', isUz ? t.growColDiscount : t.growColRent);
    set('disclaimer', isUz ? root.dataset.disclaimerUz : root.dataset.disclaimer);

    const body = out('rows');
    if (body) {
      body.textContent = '';
      for (let n = 1; n <= 5; n += 1) {
        const p = u.price * (1 + growth / 100) ** n;
        const gain = p - u.price;
        const rent = isUz ? discount : year * n;
        const tr = document.createElement('tr');
        if (n === years) {
          tr.className = 'is-current';
        } else if (n > years) {
          tr.className = 'is-after';
        }
        [`${n}. ${t.yearSuffix}`, czk(p), `+${czk(gain)}`, czk(rent), `+${czk(gain + rent)}`, pctOf(gain + rent)].forEach((text, i) => {
          const td = document.createElement('td');
          td.textContent = text;
          if (i === 0) {
            td.className = 're-ptable__strong';
          } else if (i === 4) {
            td.className = 're-ptable__semi';
          } else if (i === 5) {
            td.className = 're-ptable__rent';
          }
          tr.appendChild(td);
        });
        body.appendChild(tr);
      }
    }
  }

  root.addEventListener('change', render);
  root.addEventListener('input', render);
  render();
}

// formulář Fluent Forms v #kontakt: výběr `jednotka` (hodnota „Byt A-204“ – končí kódem bytu),
// volba `zajem` (std / uz / living / advice) a `poznamka`. Formulář je na stránce projektu, typu
// i detailu bytu (page-rd-byt-typ.php): při načtení z adresy (?byt=…#kontakt), odkaz na stejnou
// stránku (tlačítka na detailu / typu) vyplní formulář bez načtení stránky a plynule k němu sjede.
const PREFILL_KEYS = ['byt', 'zajem', 'poznamka'];
let lastNote = '';

function applyPrefill(form, params) {
  const key = params.get('byt');
  const select = form.querySelector('select[name="jednotka"]');
  if (key && select) {
    const option = Array.from(select.options).find((o) => o.value === key || o.value.endsWith(` ${key}`));
    if (option) {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  const interest = params.get('zajem');
  if (interest) {
    const radio = Array.from(form.querySelectorAll('input[name="zajem"]')).find((r) => r.value === interest);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  const note = params.get('poznamka');
  const textarea = form.querySelector('textarea[name="poznamka"]');
  // vlastní text uživatele nepřepsat – jen prázdné pole nebo poznámku z předchozího tlačítka
  if (note && textarea && (textarea.value === '' || textarea.value === lastNote)) {
    textarea.value = note;
    lastNote = note;
  }
}

function initPrefill() {
  const form = document.querySelector('#kontakt form');
  if (!form) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  if (PREFILL_KEYS.some((k) => params.has(k))) {
    applyPrefill(form, params);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#kontakt"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) {
      return;
    }
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
      return;
    }
    if (!PREFILL_KEYS.some((k) => url.searchParams.has(k))) {
      return;
    }
    event.preventDefault();
    applyPrefill(form, url.searchParams);
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    document.getElementById('kontakt').scrollIntoView({ block: 'start' }); // plynule přes scroll-behavior (_base.scss)
  });
}

function initStdYears() {
  const card = document.querySelector('[data-palace-std]');
  if (!card) {
    return;
  }
  const button = card.querySelector('[data-palace-std-btn]');
  card.addEventListener('change', (event) => {
    const input = event.target.closest('input[name="palace-std-years"]');
    if (input && button) {
      button.href = input.dataset.href;
      button.textContent = input.dataset.label;
    }
  });
}

export default function initRealityPalace() {
  initFilter();
  initCalc();
  initPrefill();
  initStdYears();
}
